import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import ListGroup from 'react-bootstrap/ListGroup';
import { getServiceEmployees, getEmployees } from '../../services/employeeService';
import { User } from 'lucide-react';

const ArtistPickerDialog = ({ open, onOpenChange, serviceId, serviceName, onSelect }) => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);

    // If we have a serviceId, fetch employees for that service;
    // otherwise fetch all business employees as fallback
    const fetchFn = serviceId
      ? getServiceEmployees(serviceId)
      : getEmployees();

    fetchFn
      .then(res => {
        const list = res.data?.data ?? res.data ?? [];
        setEmployees(Array.isArray(list) ? list : []);
      })
      .catch(() => setEmployees([]))
      .finally(() => setLoading(false));
  }, [open, serviceId]);

  const handleSelect = (employee) => {
    onSelect(employee ? { employeeId: employee.id, employeeName: employee.name } : null);
    onOpenChange(false);
  };

  return (
    <Modal show={open} onHide={() => onOpenChange(false)} centered size="sm">
      <Modal.Header closeButton style={{ borderBottom: '2px solid #FCE4EC' }}>
        <Modal.Title className="h6" style={{ color: '#EF60A3' }}>Seleccionar artista</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small mb-3">{serviceName}</p>

        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" size="sm" style={{ color: '#EF60A3' }} />
          </div>
        ) : (
          <ListGroup variant="flush">
            <ListGroup.Item
              action
              onClick={() => handleSelect(null)}
              className="d-flex align-items-center gap-2"
            >
              <User size={16} className="text-muted" />
              Sin preferencia
            </ListGroup.Item>
            {employees.map(emp => (
              <ListGroup.Item
                key={emp.id}
                action
                onClick={() => handleSelect(emp)}
                className="d-flex align-items-center gap-2"
              >
                <User size={16} style={{ color: '#EF60A3' }} />
                {emp.name}
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ArtistPickerDialog;
